export type ScreenshotStorageObject = {
  bucket: string;
  path: string;
};

const SCREENSHOTS_BUCKET = 'screenshots';

export function resolveScreenshotStorageObject(storagePath: string): ScreenshotStorageObject {
  const trimmedPath = storagePath.trim();
  let normalizedPath = trimmedPath.replace(/^\/+/, '');

  if (trimmedPath.startsWith('http://') || trimmedPath.startsWith('https://')) {
    try {
      const url = new URL(trimmedPath);
      const storageMatch = url.pathname.match(
        /^\/storage\/v1\/object\/(?:public|sign)\/screenshots\/(.+)$/,
      );
      if (storageMatch) {
        normalizedPath = decodeURIComponent(storageMatch[1]);
      }
    } catch {
      // Keep the original value so the storage API returns a controlled error.
    }
  }

  const bucketPrefix = `${SCREENSHOTS_BUCKET}/`;

  return {
    bucket: SCREENSHOTS_BUCKET,
    path: normalizedPath.startsWith(bucketPrefix)
      ? normalizedPath.slice(bucketPrefix.length)
      : normalizedPath,
  };
}
